import React, { useEffect, useState } from "react";
import { ClipLoader } from "react-spinners";
import CustomButton from "../../../components/Form/ArrowButton";
import PayPal from "../../../assets/Icons/Paypal.svg";
import ProgressBar from "../../../components/Form/ProgressBar";
import Modal from "../../../components/Modal";
import Checkbox from "../../../components/Form/Checkbox";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useThunk } from "../../../hooks/useThunk";
import { createPaypalCheckout, fetchUserOrderById, getUserWallet, payOrderWithWallet } from "../../../store";//.
import showToast from "../../../utils/toastNotifications";
import { formatYYYY_MM_DD, formatYYYY_MM_DD_HH_MM_A } from "../../../utils/dateFormating";
import { currencyFormatter } from "../../../utils/formatting";
import { twMerge } from "tailwind-merge";
import { orderStatus, paymentMethods } from "../../../constants/commonConstants";

const SecurePayment = () => {

  const wallet = useSelector((state) => state.user.wallet)// wallet 
  const isWalletFetching = useSelector((state) => state.user.isWalletFetching) // wallet isFetching state
  
  const navigate = useNavigate();
  const params = useParams();
  
  // Progressbar functions
  const steps = [
    { fullLabel: "Calculation", shortLabel: "Calculation" },
    { fullLabel: "Paper Instructions", shortLabel: "Instructions" },
    { fullLabel: "Secure Payment", shortLabel: "Payment" },
  ];

  // defining local states
  const [currentOrder, setCurrentOrder] = useState(null);
  const [doPayConfirmation, setDoPayConfirmation] = useState({bool: false, type: ''});

  const [message, setMessage] = useState(""); // Display a message to the user
  
  // defining custom hooks
  const [doFetchUserOrderById, isFetchUserOrderById, fetchUserOrderByIdError] = useThunk(fetchUserOrderById);
  const [doCreatePaypalCheckout, isCreatePaypalCheckout, createPaypalCheckoutError] = useThunk(createPaypalCheckout);
  const [doPayOrderWithWallet, isPayOrderWithWallet, errorPayOrderWithWallet] = useThunk(payOrderWithWallet);
  const [doGetUserWallet, errorGetUserWallet] = useThunk(getUserWallet);

  // defining side efefcts
  // fetch the order details from the path variable or navigates to the calculation age if the order id not found
  useEffect(() => {
    if (!params['*'] || params['*']?.toString()?.length < 1) {
      navigate("/calculation");
    } else {
      fetchOrdersByIdMethod();
      if(!(isWalletFetching === null) && !(isWalletFetching === true)){ // avoid multiple fetching requests on page refresh
        fetchUserWalletMethod();
      }
    }
  }, []);

  const handleBack = () => {
    navigate(-1);
  };

  const handleProceed = () => {
    navigate("/success-payment");
  };

  // fetch order by it;s id
  const fetchOrdersByIdMethod = async (param) => {
    const result = await doFetchUserOrderById({ id: params['*'] });
    if (result?.success) {
      setCurrentOrder(result?.response?.data);
    } else {
      showToast('error', result?.error?.message)
    }
  };

  // fetching current user wallet
  const fetchUserWalletMethod = async() => {
    const result = await doGetUserWallet();
    if(!result?.success){      
      showToast("error", result?.error?.message || "Error Occurred")
    }
  };

  // do payment with the wallet
  const handleProceedWithWallet = async() => {
    setDoPayConfirmation({...doPayConfirmation, bool: false, type: ''})
    if(currentOrder){
      const result = await doPayOrderWithWallet({id: currentOrder?._id});
      if(result.success){
        showToast("success", result?.response?.message || "Payment Done Successfully.");
        fetchOrdersByIdMethod();
        fetchUserWalletMethod();
        navigate(`/thread?roomIdParam=${result?.response?.data?.id}&threadIdParam=${result?.response?.data?.threadId}`);
      }else{
        showToast("error", result?.error?.message || "Error Occurred")
      }

    }else{
      showToast("error", "Order details not found!");
      return;
    }
  }

  // do payment with the paypal
  const handleProceedWithPayPal = async () => {
    setDoPayConfirmation({...doPayConfirmation, bool: false, type: ''})
    if (!currentOrder) {
      showToast("error", "Order details not found!");
      return;
    }

    // setLoading(true);

    // Prepare order data to send to the server
    const orderData = {
      items: [
        {
          id: currentOrder?._id,
          name: currentOrder?._id || "Unknown Item",
          description: currentOrder?.user?.typeOfPaper + ' ' +currentOrder?.orderRequirements?.academicLevel +' '+ currentOrder?.orderRequirements?.typeOfPaper || "Order Details",
          quantity: 1,
          unit_price: currentOrder?.price || "0.00",
        },
      ],
      totalAmount: currentOrder?.price || "0.00",
      currency: "USD",
    };

    try {
      const result = await doCreatePaypalCheckout(orderData);

      console.log("result from pp")
      console.log(result);
      
      if (result?.success) {
        const { approveUrl } = result?.response;
        window.location.href = approveUrl;
      } else {
        showToast("error", result?.error?.message || "Failed to create PayPal checkout session");
      }
    } catch (error) {
      showToast("error", error.message || "Error during payment initiation");
    }
  };
console.log(currentOrder);

  return (
    <div className="flex min-w-[340px] flex-col flex-grow h-screen overflow-x-hidden">
      <div className="text-primary font-roboto font-semibold text-[24px] pb-4 ml-[24px] xl:mt-[24px] mt-[104px]">
        <h2 className="xl:hidden">Dashboard</h2>
      </div>
      <div className="overflow-y-auto xl:mt-10 mb-[48px]">
        <div className=" bg-white mt-[32px] font-inter flex flex-col justify-center items-center   lg:mx-[48px] mx-[24px]  border-[1px] border-medium-gray  rounded-lg py-8  md:py-10  max-w-full  md:max-w-[2200px] px-[16px] md:px-[24px] lg:px-[48px] xl:px-0 w-auto   ">
          <div className="w-full flex items-center flex-col ">
            <div className="grid grid-cols-1 gap-x-6 w-full justify-center items-center ">
              <div className="mb-10 ">
                <ProgressBar steps={steps} activeStep={3} completedStep={2} />{" "}
              </div>

              <div className="flex flex-col w-full   items-center">
                <div className="w-full  flex-col items-center sm:w-[500px] md:w-[620px] lg:w-[580px] xl:w-[664px] flex px-0 xs:px-4 sm:px-0 ">
                  <span className="text-[18px] w-full sm:w-[500px] md:w-[620px] lg:w-[580px] xl:w-[664px] flex items-start text-gray font-roboto  justify-between  font-semibold  leading-[27px] ">
                    Order Summary
                  </span>

                  <div className="border border-medium-gray max-w-full sm:w-[500px] md:w-[620px] lg:w-[580px] xl:w-[664px] w-full h-auto sm:h-[300px] rounded-[5px] font-inter md:text-[16px] mt-3 overflow-auto scrollbar-thin">
                    {!isFetchUserOrderById && [
                       {
                        label: "Writing Type",
                        value:
                          `${currentOrder?.orderRequirements?.writingType || "-"}`,
                      },
                      {
                        label: "Type of Paper",
                        value:
                          `${currentOrder?.orderRequirements?.typeOfPaper || "-"}`,
                      },
                      // currentOrder?.orderRequirements?.removeAiContent && {
                      //   label: "Type of Order",
                      //   value: "Humanizing",
                      // },
                      {
                        label: "Academic Level",
                        value:
                          currentOrder?.orderRequirements?.academicLevel || "-",
                      },
                      {
                        label: "Type Of English",
                        value:
                          currentOrder?.orderRequirements?.typeOfEnglish || "-",
                      },
                      {
                        label: "Subject",
                        value: currentOrder?.orderRequirements?.subject || "-",
                      },
                      {
                        label: "Topic",
                        value: currentOrder?.orderRequirements?.topic || "-",
                      },
                      {
                        label: "Pages, Slides",
                        value: `${currentOrder?.orderRequirements?.pages || 0}, ${currentOrder?.orderRequirements?.slides || 0}`,
                      },
                      {
                        label: "Deadline",
                        value: formatYYYY_MM_DD_HH_MM_A(
                          currentOrder?.orderRequirements?.deadline || ""
                        ),
                      },
                      {
                        label: "Cost",
                        value: currencyFormatter.format(currentOrder?.price || 0) || "$ 00.00",
                      },
                    ].map((item, idx) => (
                      <div
                        key={idx}
                        className="flex justify-between ml-3 mt-[11px] items-center mb-[4px] sm:mb-[10px]"
                      >
                        <span className="text-gray font-normal leading-[30px] w-[154px] text-level-5 sm:text-level-4 md:text-[16px]">
                          {item?.label}
                        </span>
                        <div className="flex flex-row flex-grow"></div>
                        <span className="flex justify-end text-right pr-3 text-secondary font-medium leading-[29.98px] max-w-full text-level-5 md:max-w-[2200px] sm:text-level-4 md:text-[16px]  mx-auto w-[48%] sm:w-[58%] md:w-[48%] lg:w-[48%]">
                          {item?.label !== "Remove AI Content" && item?.value}
                          {
                            item?.label === "Remove AI Content" && 
                              <Checkbox
                                name="removeAiContent"
                                checked={item?.value}
                                onChange={()=>{}}
                                // value="agree"
                                label="Humanize"
                                containerStyle=""
                              />   
                          }
                        </span>
                      </div>
                    ))}
                    {isFetchUserOrderById && (
                        <>
                          <div className="flex justify-center items-center w-full h-[100%]">
                            <ClipLoader
                              loading={isFetchUserOrderById}
                              speedMultiplier={0.5}
                              size={82}
                              color="#60a5fa"
                            /> 
                          </div>
                        </>
                      )
                    }
                  </div>

                  <div className="lg:w-[664px] h-[18px] mt-6 flex flex-col items-center "></div>

                  <div className={twMerge("flex items-center  justify-center font-inter  mt-6 w-full xs:w-[260px] sm:w-[300px] h-[44px] rounded-[8px]", currentOrder?.status !== orderStatus.PENDING_PAYMENT ? `bg-slate-200 opacity-70` : `bg-[#FFC43A] cursor-pointer`)}
                    onClick={currentOrder?.status !== orderStatus.PENDING_PAYMENT ? () => {} : () => {setDoPayConfirmation({...doPayConfirmation, bool: true, type: paymentMethods.PAYPAL})}}
                    disabled={currentOrder?.status !== orderStatus.PENDING_PAYMENT}
                  >
                    {!isCreatePaypalCheckout && (
                      <>
                        <button className=" text-[#253B80] text-level-5 font-normal   leading-[16px]  " disabled={currentOrder?.status !== orderStatus.PENDING_PAYMENT}
                        >
                          Pay with
                        </button>
                        <img
                          src={PayPal}
                          alt="Payment"
                          className="w-[60px] h-[15px]"
                        />
                      </>
                    )}
                    {isCreatePaypalCheckout && (
                      <>
                        <ClipLoader
                          loading={isCreatePaypalCheckout}
                          speedMultiplier={0.5}
                          size={22}
                          color="#60a5fa"
                        /> 
                      </>
                    )}
                  </div>

                  <div
                    className={twMerge(`flex items-center justify-center font-inter mt-4  w-full xs:w-[260px] sm:w-[300px] h-[44px] rounded-[8px]`, (currentOrder?.status !== orderStatus.PENDING_PAYMENT || isWalletFetching) ? `bg-slate-200 opacity-70` : `bg-[#FFC43A] cursor-pointer`)}
                    // onClick={handleWalletPayment}
                  >
                    <button
                      onClick={() => {setDoPayConfirmation({...doPayConfirmation, bool: true, type: paymentMethods.WALLET})}}
                      className={"text-[#253B80] text-level-5 font-normal leading-[16px] flex justify-center items-center"}
                      disabled={currentOrder?.status !== orderStatus.PENDING_PAYMENT || isWalletFetching}
                    >
                      {(isPayOrderWithWallet) ? (
                        <>
                          <ClipLoader
                            loading={isPayOrderWithWallet}
                            speedMultiplier={0.5}
                            size={22}
                            color="#60a5fa"
                          /> 
                        </>
                      ) : (
                      <>
                        Pay with Wallet :&nbsp;
                          {( isWalletFetching) ? (
                            <>
                              <ClipLoader
                                loading={isWalletFetching}
                                speedMultiplier={0.5}
                                size={22}
                                color="#60a5fa"
                              /> 
                            </>
                        ) :  (
                        `current Wallet - ${currencyFormatter.format(wallet?.amount || 0) || '$ 00.00'}`
                        )}
                      </>
                      )}
                    </button>
                  </div>

                  <span className="text-level sm:text-[15px] text-gray font-inter font-normal leading-[18.15px] mt-5">
                    {message}
                  </span>

                  <div className="font-roboto flex justify-center flex-row gap-y-6 mt-6 w-full">
                    <CustomButton
                      text="Back"
                      iconDirection="left"
                      iconPosition="before"
                      onClick={handleBack}
                      width="100px sm:120px"
                    />
                    {/* <CustomButton
                      text={
                        <>
                          <span className="sm:hidden">Next</span>{" "}
                          <span className="hidden sm:inline">
                            Proceed Payment
                          </span>{" "}
                        </>
                      }
                      iconDirection="right"
                      iconPosition="after"
                      width="60px sm:260px"
                      onClick={handleProceed}
                      classname="transition-all duration-500 ease-in-out"
                      disabled={true}
                    /> */}
                  </div>
                  <span className="text-level sm:text-[15px] text-gray font-inter font-normal leading-[18.15px] mt-5">
                    Secure payment via PayPal
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>{" "}
      </div>
      {/* confirmation modela */}
      <Modal
        isOpen={doPayConfirmation.bool}
        onClose={() => setDoPayConfirmation({...doPayConfirmation, bool: false})}
        onConfirm={doPayConfirmation.type === paymentMethods.PAYPAL ? handleProceedWithPayPal : doPayConfirmation.type === paymentMethods.WALLET ? handleProceedWithWallet : () => {}}
        title="Please Confirm the Payment"
        content="Are you sure you want to proceed the payment?"
        cancelText="Cancel"
        confirmText="Process"
        buttonType="success"
      />
    </div>
  );
};

export default SecurePayment;
